<template>
  <div
    class="search-results-container"
  >
    <div class="bottom-padding">
      <ul>
        <li
          v-if="searchData.FirstName.length > 0"
          v-html="$t('results.li1a', { FirstName: searchData.FirstName, LastName: searchData.LastName, DOB: searchData.birthdate })"
        />
        <li
          v-else
          v-html="$t('results.li1b', { PID: searchData.PID })"
        />
        <li v-if="errorDate">
          <i> {{ $t('results.li2', { updateDate: errorDate() } ) }} </i>
        </li>
      </ul>
    </div>
    <div class="search-results-container">
      <div class="border-left">
        <br><h1 class="is-size-5">
          {{ $t('no-inmate.h1') }}
        </h1>
      </div>
    </div>
    <button
      class="button custom"
      @click="clearData"
    >
      {{ $t('button.again') }}
    </button>
  </div>
</template>

<script>

import moment from 'moment';

export default {
  name: 'SearchError',
  props: {
  },
  methods: {
    errorDate() {
      if(this.$store.state.message != "") {
        return moment(this.$store.state.message).format('LLL');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    font-size: 1.25em;
    padding-bottom: .75em;
  }

  .border-left {
    border-left: 1px solid #a1a1a1;
  }

  .result-message {
    max-width: 500px;
    padding-bottom: .75em;
  }
</style>
